import { createApp, ref } from 'vue'
import App from './App.vue'
import router from './router'
import VueGtag from 'vue-gtag'
import { VueCookieNext } from 'vue-cookie-next'
import '@/assets/css/main.css'




const app = createApp(App);
app.use(router);
app.use(VueCookieNext);
app.use(VueGtag, {
  config: { id: 'GTM-5X4L7ML' },
  router,
  enabled: true,
});


app.provide('gtag', app.config.globalProperties.$gtag);
app.provide('noAdsPage', app.config.globalProperties.$noAdsPage = false);


app.mount('#app');







//createApp(App).mount('#app')

require('./assets/js/top-menu-icon.js')

